export default {
  'pages.layouts.userLayout.title': 'طراحی مورچه تأثیرگذارترین مشخصات طراحی وب در منطقه Xihu است',
  'pages.login.accountLogin.tab': 'ورود به حساب کاربری',
  'pages.login.accountLogin.errorMessage': 'نام کاربری / رمزعبور نادرست (مدیر / ant.design)',
  'pages.login.failure': 'ورود به سیستم با شکست مواجه شد، لطفا دوباره سعی کنید!',
  'pages.login.success': 'ورود موفق!',
  'pages.login.username.placeholder': 'نام کاربری: مدیر یا کاربر',
  'pages.login.username.required': 'لطفا نام کاربری خود را وارد کنید!',
  'pages.login.password.placeholder': 'رمز عبور: ant.design',
  'pages.login.password.required': 'لطفاً رمز ورود خود را وارد کنید!',
  'pages.login.phoneLogin.tab': 'ورود به سیستم تلفن',
  'pages.login.phoneLogin.errorMessage': 'خطای کد تأیید',
  'pages.login.phoneNumber.placeholder': 'شماره تلفن',
  'pages.login.phoneNumber.required': 'لطفاً شماره تلفن خود را وارد کنید!',
  'pages.login.phoneNumber.invalid': 'شماره تلفن نامعتبر است!',
  'pages.login.captcha.placeholder': 'کد تایید',
  'pages.login.captcha.required': 'لطفا کد تأیید را وارد کنید!',
  'pages.login.phoneLogin.getVerificationCode': 'دریافت کد',
  'pages.getCaptchaSecondText': 'ثانیه',
  'pages.login.rememberMe': 'مرا به خاطر بسپار',
  'pages.login.forgotPassword': 'رمز عبور را فراموش کرده اید ?',
  'pages.login.submit': 'ارسال',
  'pages.login.loginWith': 'وارد شوید با :',
  'pages.login.registerAccount': 'ثبت نام',
  'pages.welcome.link': 'خوش آمدید',
  'pages.welcome.alertMessage': 'اجزای سنگین تر سریعتر و قوی تر آزاد شده اند.',
  'pages.404.subTitle': 'ببخشيد، صفحه اي که ديديد وجود نداره',
  'pages.404.buttonText': 'بازگشت به صفحه اصلی',
  'pages.admin.subPage.title': 'این صفحه فقط توسط مدیر قابل مشاهده است',
  'pages.admin.subPage.alertMessage':
    'رابط کاربری Umi اکنون منتشر شده است ، برای شروع تجربه استفاده از npm run ui خوش آمدید.',
  'pages.searchTable.createForm.newRule': 'قانون جدید',
  'pages.searchTable.updateForm.ruleConfig': 'پیکربندی قانون',
  'pages.searchTable.updateForm.basicConfig': 'اطلاعات اولیه',
  'pages.searchTable.updateForm.ruleName.nameLabel': ' نام قانون',
  'pages.searchTable.updateForm.ruleName.nameRules': 'لطفاً نام قانون را وارد کنید!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'شرح قانون',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'لطفاً حداقل پنج حرف وارد کنید',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'لطفاً حداقل یک قانون حاوی پنج کاراکتر شرح دهید!',
  'pages.searchTable.updateForm.ruleProps.title': 'پیکربندی خصوصیات',
  'pages.searchTable.updateForm.object': 'نظارت بر شی',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'الگوی قانون',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'نوع قانون',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'تنظیم دوره زمان بندی',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'زمان شروع',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'لطفاً زمان شروع را انتخاب کنید!',
  'pages.searchTable.titleDesc': 'شرح',
  'pages.searchTable.ruleName': 'نام قانون لازم است',
  'pages.searchTable.titleCallNo': 'تعداد تماس های خدماتی',
  'pages.searchTable.titleStatus': 'وضعیت',
  'pages.searchTable.nameStatus.default': 'پیش فرض',
  'pages.searchTable.nameStatus.running': 'در حال دویدن',
  'pages.searchTable.nameStatus.online': 'برخط',
  'pages.searchTable.nameStatus.abnormal': 'غیرطبیعی',
  'pages.searchTable.titleUpdatedAt': 'آخرین برنامه ریزی در',
  'pages.searchTable.exception': 'لطفا دلیل استثنا را وارد کنید!',
  'pages.searchTable.titleOption': 'گزینه',
  'pages.searchTable.config': 'پیکربندی',
  'pages.searchTable.subscribeAlert': 'مشترک شدن در هشدارها',
  'pages.searchTable.title': 'فرم درخواست',
  'pages.searchTable.new': 'جدید',
  'pages.searchTable.chosen': 'انتخاب شده',
  'pages.searchTable.item': 'مورد',
  'pages.searchTable.totalServiceCalls': 'تعداد کل تماس های خدماتی',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'حذف دسته ای',
  'pages.searchTable.batchApproval': 'تصویب دسته ای',

  // Public Holiday Management
  'holidayManagement.title': 'مدیریت تعطیلات رسمی',
  'holidayManagement.content': 'مدیریت تعطیلات رسمی برای سازمان شما',
  'holidayManagement.holidayList': 'لیست تعطیلات',
  'holidayManagement.addNewHoliday': 'افزودن تعطیلات جدید',
  'holidayManagement.editHoliday': 'ویرایش تعطیلات',
  'holidayManagement.addHoliday': 'افزودن تعطیلات',
  'holidayManagement.createSuccess': 'تعطیلات با موفقیت ایجاد شد',
  'holidayManagement.updateSuccess': 'تعطیلات با موفقیت به‌روزرسانی شد',
  'holidayManagement.deleteSuccess': 'تعطیلات با موفقیت حذف شد',
  'holidayManagement.deleteFailed': 'حذف ناموفق بود',
  'holidayManagement.operationFailed': 'عملیات ناموفق بود',
  'holidayManagement.deleteConfirm': 'آیا مطمئن هستید که می‌خواهید این تعطیلات را حذف کنید؟',
  'holidayManagement.name': 'نام تعطیلات',
  'holidayManagement.description': 'توضیحات',
  'holidayManagement.date': 'تاریخ',
  'holidayManagement.countryCode': 'کشور',
  'holidayManagement.stateCode': 'ایالت/منطقه',
  'holidayManagement.isNational': 'تعطیلات ملی',
  'holidayManagement.status': 'وضعیت',
  'holidayManagement.action': 'عملیات',
  'holidayManagement.edit': 'ویرایش',
  'holidayManagement.delete': 'حذف',
  'holidayManagement.yes': 'بله',
  'holidayManagement.no': 'خیر',
  'holidayManagement.active': 'فعال',
  'holidayManagement.inactive': 'غیرفعال',
  'holidayManagement.searchName': 'جستجو بر اساس نام تعطیلات',
  'holidayManagement.searchDescription': 'جستجو بر اساس توضیحات',
  'holidayManagement.holidayName': 'نام تعطیلات',
  'holidayManagement.pleaseEnterHolidayName': 'لطفاً نام تعطیلات را وارد کنید',
  'holidayManagement.pleaseSelectDate': 'لطفاً تاریخ را انتخاب کنید',
  'holidayManagement.pleaseSelectCountry': 'لطفاً کشور را انتخاب کنید',
  'holidayManagement.pleaseSelectState': 'لطفاً ایالت/منطقه را انتخاب کنید',
  'holidayManagement.isActive': 'فعال',
  'holidayManagement.showing': 'نمایش',
  'holidayManagement.of': 'از',
  'holidayManagement.items': 'مورد',

  // نام‌های تعطیلات رسمی هنگ کنگ
  'holidayManagement.holidayNames.newYearsDay': 'روز سال نو',
  'holidayManagement.holidayNames.lunarNewYearsDay': 'روز سال نو قمری',
  'holidayManagement.holidayNames.secondDayOfLunarNewYear': 'روز دوم سال نو قمری',
  'holidayManagement.holidayNames.thirdDayOfLunarNewYear': 'روز سوم سال نو قمری',
  'holidayManagement.holidayNames.chingMingFestival': 'جشنواره چینگ مینگ',
  'holidayManagement.holidayNames.goodFriday': 'جمعه خوب',
  'holidayManagement.holidayNames.dayFollowingGoodFriday': 'روز بعد از جمعه خوب',
  'holidayManagement.holidayNames.easterMonday': 'دوشنبه عید پاک',
  'holidayManagement.holidayNames.labourDay': 'روز کارگر',
  'holidayManagement.holidayNames.buddhaBirthday': 'تولد بودا',
  'holidayManagement.holidayNames.tuenNgFestival': 'جشنواره توئن نگ',
  'holidayManagement.holidayNames.hkEstablishmentDay': 'روز تأسیس منطقه اداری ویژه هنگ کنگ',
  'holidayManagement.holidayNames.nationalDay': 'روز ملی',
  'holidayManagement.holidayNames.dayFollowingMidAutumn': 'روز بعد از جشنواره نیمه پاییز چینی',
  'holidayManagement.holidayNames.chungYeungFestival': 'جشنواره چونگ یانگ',
  'holidayManagement.holidayNames.christmasDay': 'روز کریسمس',
  'holidayManagement.holidayNames.firstWeekdayAfterChristmas': 'اولین روز کاری بعد از کریسمس',
  'holidayManagement.quickAddCommonHoliday': 'افزودن سریع تعطیلات معمول',
  'holidayManagement.originalName': 'نام اصلی',
};
